import { authorizedApi } from './index';

export const serverWalletsApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    createServerWallet: builder.mutation({
      query: ({ purpose, chainType = 'solana', name, description }) => ({
        url: '/admin/server-wallets',
        method: 'POST',
        body: {
          purpose,
          chainType,
          name,
          description,
        },
      }),
    }),
    getServerWallet: builder.query({
      query: ({ name, purpose, chainType = 'solana' }) => ({
        url: '/admin/server-wallets',
        method: 'GET',
        params: {
          ...(name ? { name } : {}),
          ...(purpose ? { purpose } : {}),
          ...(chainType ? { chainType } : {}),
        },
      }),
    }),
  }),
});

export const {
  useCreateServerWalletMutation,
  useGetServerWalletQuery,
} = serverWalletsApi;
